import { REPORTS_MODE_CONFIG_PRICING } from "../../framework/tab/tabUtilsConstants";
import { dateFilterComparator } from "../../utils/utils";
import moment from "moment";
import Checkbox from "../../framework/Checkbox";

export const columnDefs = [
  {
    headerName: "checked",
    field: "checked",
    width: 50,
    floatingFilter: false,
  },
  {
    headerName: "Mode Config Id",
    field: "modeConfigId",
    locked: true,
    width: 80,
  },
  {
    headerName: "Group Name",
    field: "groupName",
    hide: true,
    width: 150,
  },
  {
    headerName: "Dosage Mark",
    field: "dosageMark",
    locked: false,
    width: 150,
  },
  {
    headerName: "Description",
    field: "description",
    locked: true,
    width: 200,
  },
  {
    headerName: "Mode Category",
    field: "modeCategory",
    locked: false,
    width: 200,
  },
  {
    headerName: "Base Proportion Liquid",
    field: "baseProportionLiquid",
    locked: false,
    cellClass: "custom-ag-cell-numeric",
    width: 150,
  },
  {
    headerName: "Base Proportion Globules",
    field: "baseProportionGlobules",
    locked: false,
    cellClass: "custom-ag-cell-numeric",
    width: 150,
  },
  {
    headerName: "Potency",
    field: "potency",
    locked: false,
    width: 200,
  },
  {
    headerName: "Packaging",
    field: "packaging",
    locked: false,
    cellClass: "custom-ag-cell-numeric",
    width: 100,
  },
  {
    headerName: "Price",
    field: "rate",
    locked: false,
    cellClass: "custom-ag-cell-numeric",
    width: 100,
  },
  {
    headerName: "GST %",
    field: "gstPercent",
    locked: false,
    cellClass: "custom-ag-cell-numeric",
    width: 100,
  },
  {
    headerName: "DP %",
    field: "dpPercentage",
    locked: false,
    cellClass: "custom-ag-cell-numeric",
    width: 100,
  },
  {
    headerName: "Company",
    field: "company",
    locked: false,
    width: 150,
  },
  {
    headerName: "Created By",
    field: "createdBy",
    width: 150,
    hide: true,
  },
  {
    headerName: "Created Time",
    field: "createdTime",
    locked: false,
    width: 150,
  },
  {
    headerName: "Updated By",
    field: "updatedBy",
    locked: false,
    width: 150,
  },
  {
    headerName: "Updated Time",
    field: "updatedTime",
    locked: false,
    width: 150,
  },
];

export const columnDefsFunctions = {
  checked: {
    cellRendererFramework: (params) => {
      return (
        <Checkbox
          checked={params.data.checked}
          onChange={(event) => {
            params.data.checked = event.target.checked;
            params.api.redrawRows({
              rowNodes: [params.api.getRowNode(params.node.rowIndex)],
            });
          }}
        />
      );
    },
    headerComponentFramework: (params) => {
      let allRowsChecked = false;
      let count = 0;
      params.api.forEachNode((node) => {
        if (node.data.checked) count++;
        if (count === params.api.getDisplayedRowCount()) {
          allRowsChecked = true;
        } else {
          allRowsChecked = false;
        }
      });
      return (
        <Checkbox
          checked={allRowsChecked}
          onChange={(event) => {
            params.api.forEachNode((node) => {
              node.data.checked = event.target.checked;
              params.api.redrawRows({
                rowNodes: [params.api.getRowNode(node.rowIndex)],
              });
            });
            allRowsChecked = event.target.checked;
            params.api.refreshHeader();
          }}
        />
      );
    },
  },
  modeConfigId: {
    cellClass: (params) =>
      params.data.modeConfigId === "Filtered Total"
        ? "ag-header-group-cell-label"
        : "custom-ag-cell-link",
  },
  createdTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
};

export const initial_state_mode_config_pricing_reports = {
  type: REPORTS_MODE_CONFIG_PRICING,
  label: "Mode Config Pricing Reports",
  allowMultipleTabs: false,
};
